// Diagnostics panel: 12-lead ECG, ABG, glucose, POCUS, CXR, etc.
import Drawer from './Drawer';

interface Props {
  open: boolean;
  onClose: () => void;
  onAction: (action_type: string, payload?: any) => void;
}

const TESTS = [
  { type: 'ecg_12_lead',    label: '12-lead ECG',          notes: 'STEMI / ischaemia / arrhythmia evidence' },
  { type: 'abg',            label: 'ABG',                  notes: 'Acid-base, lactate, pO₂. ~60s result.' },
  { type: 'vbg',            label: 'VBG',                  notes: 'Faster venous sample; less accurate pO₂.' },
  { type: 'poc_glucose',    label: 'Capillary glucose',    notes: 'Always check — reversible cause.' },
  { type: 'poc_lactate',    label: 'POC lactate',          notes: 'Tissue perfusion marker.' },
  { type: 'bedside_echo',   label: 'Bedside echo (RUSH/4-view)', notes: 'RV strain (PE), pericardial effusion, IVC, LV function.' },
  { type: 'lung_us',        label: 'Lung US',              notes: 'Pneumothorax (sliding), B-lines (oedema).' },
  { type: 'fast_scan',      label: 'FAST scan',            notes: 'Free fluid (haemoperitoneum, tamponade).' },
  { type: 'cxr_portable',   label: 'Portable CXR',         notes: '~3 min. Pneumothorax, ETT position, lung pathology.' },
  { type: 'troponin',       label: 'Troponin (lab)',       notes: 'Slower; STEMI diagnosis is ECG-led.' },
  { type: 'potassium',      label: 'Urgent K⁺ (lab)',      notes: 'Hyperkalaemia confirmation. ABG K⁺ first.' },
  { type: 'core_temp_probe',label: 'Core temperature probe', notes: 'Hypothermia diagnosis; tympanic unreliable.' },
];

export default function DiagnosticsPanel({ open, onClose, onAction }: Props) {
  return (
    <Drawer open={open} onClose={onClose} title="Diagnostics" width="md">
      <p className="text-xs text-mono-white/50 mb-3">Pursuing the 4Hs and 4Ts — each test points at a reversible cause.</p>
      <div className="space-y-2">
        {TESTS.map((t) => (
          <button
            key={t.type}
            onClick={() => { onAction(t.type); onClose(); }}
            className="w-full text-left p-3 rounded bg-ink-800 hover:bg-ink-950 transition-colors border border-transparent hover:border-brand-600"
          >
            <div className="font-medium">{t.label}</div>
            <div className="text-xs text-mono-white/50 mt-1">{t.notes}</div>
          </button>
        ))}
      </div>
    </Drawer>
  );
}
